import { Box } from '@mui/material';
import './App.css';
import TopNavBar from './layout/TopNavBar';
import MobileSwitch from './components/mobile/mobileSwitch';
import backgroundSvg from './assets/background.svg';
import { Outlet, useLocation } from 'react-router-dom';
import Dashboard from './layout/Dashboard';

function App() {
  const pathName = useLocation().pathname;
  return (
    <Box
      sx={{
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: `
          radial-gradient(51.58% 90.25% at 30.88% -30.81%, 
            rgba(0, 216, 165, 0.9) 0%, 
            rgba(0, 205, 158, 0.9) 3%, 
            rgba(0, 151, 124, 0.9) 22%, 
            rgba(0, 106, 95, 0.9) 40%, 
            rgba(0, 71, 73, 0.9) 57%, 
            rgba(0, 46, 57, 0.9) 73%, 
            rgba(0, 31, 48, 0.9) 88%, 
            rgba(0, 26, 45, 0.9) 99%
          ),
          url(${backgroundSvg})
        `,
        backgroundRepeat: 'no-repeat, no-repeat',
        backgroundPosition: 'center, top'
      }}
    >
      <TopNavBar />
      <MobileSwitch />
      {pathName === '/' && <Dashboard />}
      <Outlet />
    </Box>
  );
}

export default App;
